<template>
  <div
    class="upload-view TranslateUploadPDFItem"
    :class="{
      'enterprise-text-translate': enterpriseMode,
      'has-messages': enterpriseMode && messages.length > 0,
    }"
  >
    <div class="homepageBg" @wheel="handleScroll">
      <div class="upload_main">
        <div class="ai-chat-box" ref="chatContentRef">
          <ChatContent ref="chatContent" @resetSendQusition="onResetSendQusition" :type="2" :messages="messages"
            @updateContentHeight="scrollContentToBottom" @animationFinish="onAnimationFinish" @proBuy="onProBuy"
            v-if="messages.length" />
        </div>
        <div class="ai-all-box">
          <div class="ai-order-box" v-if="token && (!enterpriseMode || messages.length > 0)">
            <div class="ai-order-box-left">
              <div v-if="messages.length > 0"
                :class="`${messages.length == 0 ? 'ai-question-unClick-btn' : 'ai-question-btn'}`" @click="onSpoken">
                <div class="ai-question-btn-text">{{ $t('translate_ai_spoken_language') }}</div>
              </div>
              <div v-if="messages.length > 0"
                :class="`${messages.length == 0 ? 'ai-question-unClick-btn' : 'ai-question-btn'}`"
                style="margin-left: 10px;" @click="onAcademic">
                <div class="ai-question-btn-text">{{ $t('translate_ai_academic_language') }}</div>
              </div>
            </div>
            <div v-if="!enterpriseMode" class="ai-order-box-right">
              <el-tooltip effect="dark" ref="historyTooltipRef" placement="top"
                :content="$t(`translate_ai_history_dialog_title`)">
                <!-- hidden-sm-only hidden-xs-only -->
                <div class="ai-btn" @click="onHistory">
                  <i class="iconfont icon-icon_History" style="font-size: 18px;color:#595959; cursor: pointer;" />
                </div>
              </el-tooltip>
              <el-tooltip ref="clearTooltipRef" effect="dark" placement="top" :content="$t(`translate_ai_new_chat`)">
                <!-- hidden-sm-only hidden-xs-only -->
                <div class="ai-btn" style="margin-right: 10px;" @click="onClear">
                  <i class="iconfont icon-icon_cha3"
                    style="font-size: 18px;color:#595959; cursor: pointer; color: #2590E1" />
                </div>
              </el-tooltip>
            </div>
          </div>
          <div class="ai-input-box">
            <div class="ai-input-box-top">
              <slot />
              <div class="translateChoose_top_view">
                <div class="chooseSelect chooseSelect-column">
                  <div class="chooseSelect-column-item">
                    <div class="k-shake" :class="{ ['k-shakeactive']: shakeAnimation }">
                      <!-- 翻译语言 -->
                      <div class="item-child item-child-left">
                        <el-popover ref="popoverRef" :width="800" trigger="click" popper-class="customLang-popover"
                          placement="bottom-start">
                          <template #reference>
                            <div
                              class="el-dropdown-link"
                              :style="{
                                color: enterpriseMode ? '#1F2329' : '#262626',
                                fontSize: '13px',
                                fontWeight: enterpriseMode ? '600' : 'bold',
                              }"
                            >
                              {{ currentParam.translateLangsName == "" ? (enterpriseMode ? '自动' : $t("upload_auto_check_lang")) :
                              currentParam.translateLangsName }}
                              <WorkbenchIcon v-if="enterpriseMode" name="chevron-down" :size="12" class="enterprise-text-inline-icon" />
                              <i v-else class="iconfont icon-icon_arrowsdown"
                                style="font-size: 12px; color: #262626; margin-left: 5px;" />
                            </div>
                          </template>
                          <LangListItem :langs="languages" :currentLang="currentParam.sourceLang" :type="0"
                            :commonLangs="filterCommonLangs" @onChooseLang="onSelectChange" />
                        </el-popover>
                      </div>
                      <WorkbenchIcon
                        v-if="enterpriseMode"
                        name="arrow-left-right"
                        :size="13"
                        class="enterprise-text-swap-icon"
                        @click="switchLangs"
                      />
                      <i v-else class="iconfont icon-icon_change" @click="switchLangs"
                        style="margin: 0 10px; color: #262626; cursor: pointer" />
                      <div class="item-child item-child-right">
                        <el-popover ref="popoverTargetRef" :width="800" trigger="click"
                          popper-class="customLang-popover" placement="bottom-start">
                          <template #reference>
                            <div
                              class="el-dropdown-link"
                              :style="{
                                color: currentParam.currentLangsName === ''
                                  ? (currentParam.showLangError ? '#E14C25' : (enterpriseMode ? '#98A2B3' : '#8C8C8C'))
                                  : (enterpriseMode ? '#1F2329' : '#262626'),
                                fontSize: '13px',
                                fontWeight: enterpriseMode ? '400' : 'bold',
                              }"
                            >
                              {{ currentParam.currentLangsName == "" ? $t("choose_translation_language") :
                              currentParam.currentLangsName }}
                              <WorkbenchIcon v-if="enterpriseMode" name="chevron-down" :size="12" class="enterprise-text-inline-icon" />
                              <i v-else class="iconfont icon-icon_arrowsdown"
                                style="font-size: 12px; color: #262626; margin-left: 5px;" />
                            </div>
                          </template>
                          <LangListItem :langs="languages" :currentLang="currentParam.targetLang" :type="1"
                            :commonLangs="filterCommonLangs" @onChooseLang="onTargetChange" @onLockLang="onLockLang" />
                        </el-popover>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="enterpriseMode && token" class="enterprise-text-actions">
                  <el-tooltip effect="dark" ref="historyTooltipRef" placement="top"
                    :content="$t(`translate_ai_history_dialog_title`)">
                    <button type="button" class="enterprise-text-action" aria-label="翻译历史" @click="onHistory">
                      <WorkbenchIcon name="history" :size="15" />
                    </button>
                  </el-tooltip>
                  <el-tooltip ref="clearTooltipRef" effect="dark" placement="top" :content="$t(`translate_ai_new_chat`)">
                    <button type="button" class="enterprise-text-action is-primary" aria-label="新建文本翻译" @click="onClear">
                      <WorkbenchIcon name="plus" :size="15" />
                    </button>
                  </el-tooltip>
                </div>
              </div>
              <div class="ai-input-box-input" :style="token ? 'min-height: 230px;' : 'min-height: 264px;'">
                <AITranslateInput :enterprise-mode="enterpriseMode" ref="chatInput" @sendMessage="onSendMessage" @onProBuy="onProBuy"></AITranslateInput>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, inject, onBeforeUnmount, ref, defineExpose, watch, computed, nextTick, toRaw, isProxy } from 'vue'
import eventBus from 'vue3-eventbus'
import { storeToRefs } from "pinia";
import useUserStore from "@/store/modules/user";
import useBasicStore from "@/store/modules/basic";
import Toast from "@/utils/toast";
import { getSensitiveThesaurus, filterSensitiveWords } from '@/utils'
import { useRouter, useRoute } from 'vue-router'
import type { Message, MessageEngine } from '@/data/chat/Message';
import AITranslateInput from "@/components/AITranslate/AITranslateInput.vue"
import ChatContent from "@/components/PDFChatComponents/ChatContent.vue"
import LangListItem from '@/components/TranslateComponents/LangListComponents/LangListItem.vue'
import { ChatMessage } from '@/data/chatMessage/ChatMessage';
import WorkbenchIcon from '@/components/Workbench/WorkbenchIcon.vue'
// import useSeoStore from '@/store/seo'

const router = useRouter()
const basicStore = useBasicStore()
const { sensitiveWords } = storeToRefs(basicStore)

const userStore = useUserStore();
const { token, userInfo } = storeToRefs(userStore);
const { commonLanguages, languages, isChina } = storeToRefs(basicStore)
const { t, locale } = useI18n()

let call = defineEmits(['aiHistoryOpen', 'updataEngineList', 'showLangError', 'clearChat', 'showAiTranslateDialog', 'onProBuy'])
let showRotateAnimation = ref(false)
let messages = ref<Message[]>([])
let chatContentRef = ref()
let chatContent = ref()
const isAutoScrolling = ref(true)
const chatMessage = new ChatMessage(); // 实例化 ChatMessage
const chatInput = ref()
const currentLang = ref("")
let currentRequestInfo = ref()

const clearTooltipRef = ref()
const historyTooltipRef = ref()
const popoverTargetRef = ref()
const popoverRef = ref()
let visitorChatId = ref(1)
const shakeAnimation = ref(false)
const currentParam = ref({ sourceLang: "", targetLang: "", translateLangsName: "", currentLangsName: "", showLangError: false })


defineExpose({ onSetTranslateStatus, updataData, updataCurrentEngine })

const props = withDefaults(defineProps<{
  enterpriseMode?: boolean
}>(), {
  enterpriseMode: false,
})
const enterpriseMode = computed(() => props.enterpriseMode)

// 外面切换引擎和切换翻译语言 这里会调用
function updataData(param) {
  console.log("updataData====", param)
  currentRequestInfo.value = param
  currentParam.value = param
}

// 引擎更新
function updataCurrentEngine(engineInfo) {
  console.log("updataEngine====", engineInfo)
  chatMessage.updataEngine(engineInfo)
  chatInput.value && chatInput.value.updataEngine(engineInfo)
}

function onSetTranslateStatus(status: number) {

}

function onHistory() {
  historyTooltipRef.value && historyTooltipRef.value.onClose()
  call('aiHistoryOpen')
}

function onClear() {
  messages.value = []
  chatMessage.setAIChatId(0)
  chatInput.value && chatInput.value.clearInputText()
  
  call('clearChat')
  updataData({targetLang: '', sourceLang: '', translateLangsName: '', currentLangsName: '', showLangError: false})
  clearTooltipRef.value && clearTooltipRef.value.onClose()
}

function scrollContentToBottom() {
  if (messages.value.length > 1) {
    scrollToBottom()
  }
}

function scrollToBottom() {
  if (chatContentRef.value && isAutoScrolling.value) {
    nextTick(() => {
      chatContentRef.value.scrollTop = chatContentRef.value.scrollHeight
      console.log("scrollToBottom", chatContentRef.value.scrollTop, chatContentRef.value.scrollHeight)
    })
  }
}

let lastScrollTop = 0
let currentScrollTop = 0

const handleChildScroll = (e) => {
  // 控制子元素滚动
  chatContentRef.value.scrollTop += e.deltaY;

  // 阻止事件冒泡和默认行为
  // e.preventDefault();
  // e.stopPropagation();
};

const handleScroll = (e) => {

  console.log("handleScroll", chatContentRef.value.scrollTop)

  const canScrollUp = chatContentRef.value.scrollTop > 0;
  const canScrollDown = chatContentRef.value.scrollTop <
    chatContentRef.value.scrollHeight - chatContentRef.value.clientHeight;

  // 如果还能在当前方向滚动，就阻止事件冒泡
  if ((e.deltaY < 0 && canScrollUp) || (e.deltaY > 0 && canScrollDown)) {
    e.preventDefault();
    e.stopPropagation();
    chatContentRef.value.scrollTop += e.deltaY;
  }
  const container = chatContentRef.value;
  if (container) {
    // 如果用户滚动到顶部附近，停止自动滚动
    console.log("handleScroll", container.scrollTop, container.scrollHeight - 10)
    if (container.scrollTop + container.clientHeight < container.scrollHeight - 10) {
      isAutoScrolling.value = false;
    } else {
      // 如果用户滚动到底部，恢复自动滚动
      isAutoScrolling.value = true;
      scrollToBottom();
    }

    currentScrollTop = container.scrollTop
    // 这里检测刷新
    if (container.scrollTop < 50 && lastScrollTop > currentScrollTop) {
      console.log("loadingMessageHistory", chatMessage.getCheckLoadingCompleted())
      if (!chatMessage.getCheckLoadingCompleted() && token.value) {
        chatMessage.loadingMessageHistory(((chatMessages) => {
          let currentMessage = messages.value
          let mergedMessages = [...chatMessages, ...currentMessage]
          let recordCurrentTop = container.scrollTop
          let recordAllTop = container.scrollHeight
          messages.value = mergedMessages
          chatContent.value && chatContent.value.showRefresh(false)
          // 这里保持当前top
          nextTick(() => {
            let currentAllTop = container.scrollHeight
            let scorllY = currentAllTop - recordAllTop - recordCurrentTop
            chatContentRef.value.scrollTop = scorllY
          })
          // 请求成功
        }), (() => {
          // 请求失败
          chatContent.value && chatContent.value.showRefresh(false)
        }), true)
      }
    }
    lastScrollTop = currentScrollTop
  }
};

function onSendMessage(message: string, isFree: boolean = false, translateTagType: number = 0) {
  // if (!pdfToken.value) {
  //   call('showAiTranslateDialog', 0)
  //   return
  // }
  // // 试用次数消耗殆尽
  // if (userInfo.value.vipLevel == 0 && userInfo.value.validWordsForBag == 0 && chatInput.value && chatInput.value.getTrialNum() == 0) {
  //   call('showAiTranslateDialog', 1)
  //   return
  // }
  console.log("onSendMessage", currentParam.value, message)
  if (!currentParam.value.targetLang) {
    currentParam.value.showLangError = true
    shakeAnimation.value = true
    setTimeout(() => {
      shakeAnimation.value = false
    }, 1000)

    call('showLangError')
    return
  }
  // 是否存在敏感词
  let isSensitive = createTempChat(message)
  chatInput.value && chatInput.value.clearInputText()
  if (isSensitive) {
    return
  }
  chatInput.value && chatInput.value.setDisable(true);
  chatMessage.sendAIMessage(message, currentParam.value.sourceLang, currentParam.value.targetLang, isFree, translateTagType, chatMessage.getAIChatId() ? undefined : visitorChatId.value)
}

function onAnimationFinish() {
  // chatInput.value && chatInput.value.setDisable(false);
}

function onProBuy(index) {
  call("onProBuy", index)
}

function onUpdataRemainCharsNum() {
  console.log("onUpdataRemainCharsNum==", chatMessage.getRemainNumInfo())
  chatInput.value && chatInput.value.onUpdataRemainCharsNum(chatMessage.getRemainNumInfo());
}

function deleteLastMessage() {
  setTimeout(() => {
    let deleteIndex = -1
    for (let index = 0; index < messages.value.length; index++) {
      const element = messages.value[index];
      if (element.chatId == -1) {
        deleteIndex = index
      }
    }
    if (deleteIndex >= 0) {
      messages.value.splice(deleteIndex, 1)
      chatInput.value && chatInput.value.setDisable(false);
    }
    chatInput.value && chatInput.value.setDisable(false);
  }, 500)
}

function updataEngine(allEngineMap) {
  let ordinary = []
  let senior = []
  let reasoning = []
  Object.keys(allEngineMap).forEach(key => {
    let engine = allEngineMap[key]
    engine.describe = t(`${key}_describe`)

    if (engine.highLevelFlag == 0 && (engine.showFlag != 0 && engine.showFlag != 1)) {
      ordinary.push(engine)
    } else if (engine.highLevelFlag == 1 && (engine.showFlag != 0 && engine.showFlag != 1)) {
      senior.push(engine)
    } else if (engine.highLevelFlag == 2 && (engine.showFlag != 0 && engine.showFlag != 1)) {
      reasoning.push(engine)
    }
  });
  ordinary = ordinary.sort((a, b) => {
    return a.sort - b.sort
  })
  senior = senior.sort((a, b) => {
    return a.sort - b.sort
  })
  reasoning = reasoning.sort((a, b) => {
    return a.sort - b.sort
  })
  // mode.value = ordinary
  // seniorMode.value = senior
  // reasoningMode.value = reasoning

  let engineInfo: MessageEngine;
  if (userInfo.value.vipLevel > 0 || userInfo.value.validWordsForBag > 0) {
    call('updataEngineList', chatMessage.getVipModeInfo(), ordinary, senior, reasoning)
    engineInfo = chatMessage.getVipModeInfo()
  } else {
    call('updataEngineList', chatMessage.getUserModeInfo(), ordinary, senior, reasoning)
    engineInfo = chatMessage.getUserModeInfo()
  }

  chatMessage.updataEngine(engineInfo)
  chatInput.value && chatInput.value.updataEngine(engineInfo)
}

function createTempChat(text): boolean {
  let { filterText, isSensitive } = filterSensitiveWords(text, sensitiveWords.value)
  console.log("createTempChat===", text, filterText, messages.value, sensitiveWords.value)
  let tempMessage: Message = {
    chatId: 0,
    msgContent: JSON.stringify({ text: filterText }),
    msgJsonContent: { text: filterText },
    isAnimation: false,
    aiRespFlag: 0,
    createTime: "",
    costCharsNum: 0,
    fileDocIds: "",
    id: 0,
    operateRecordId: 0,
    tmpVisitorToken: "",
    updateTime: "",
    userId: 0,
    msgType: 1
  }
  messages.value.push(tempMessage);

  // 如果出现敏感词
  if (isSensitive) {
    let continueMessage = chatMessage.createWelcomeMessage("", t('chat_sensitive_words_content_ai'))
    messages.value = [...messages.value, ...continueMessage]
    return true
  }
  setTimeout(() => {
    let questionMessage: Message = {
      chatId: -1,
      isAnimation: true,
      aiRespFlag: 1,
      msgContent: "",
      msgJsonContent: { text: '' },
      createTime: "",
      costCharsNum: 0,
      fileDocIds: "",
      id: 0,
      operateRecordId: 0,
      tmpVisitorToken: "",
      updateTime: "",
      userId: 0,
      msgType: 1,
    }
    messages.value.push(questionMessage);
  }, 500)

  isAutoScrolling.value = true
  scrollToBottom()

  return false
}

function onHistoryRefresh() {
  const container = chatContentRef.value;
  if (container && token.value) {
    chatMessage && chatMessage.loadingMessageHistory(((chatMessages) => {
      let currentMessage = messages.value
      let mergedMessages = [...chatMessages, ...currentMessage]
      messages.value = mergedMessages
      chatContent.value && chatContent.value.showRefresh(false)
      isAutoScrolling.value = true
      scrollToBottom()

      // 请求成功
    }), (() => {
      // 请求失败
      chatContent.value && chatContent.value.showRefresh(false)
    }), true)
  }
}

function onResetSendQusition(content) {
  onSendMessage(content.content, content.isFree)
}

// 口语化
function onSpoken() {
  if (chatInput.value && chatInput.value.getDisable()) {
    return
  }
  if (messages.value.length == 0) {
    return
  }
  onSendMessage(t('translate_ai_spoken_content'), false, 1)
}

// 学术化
function onAcademic() {
  if (chatInput.value && chatInput.value.getDisable()) {
    return
  }
  if (messages.value.length == 0) {
    return
  }
  onSendMessage(t('translate_ai_academic_content'), false, 2)
}

function getUserByToken() {
  if (!token.value) {
    return
  }
  // getRequestAccountUserInfo().then((data) => {
  //   if (data.code == '1') {
  //     userInfo.value = data.data
  //     localStorage.setItem("user", JSON.stringify(data.data))
  //   }
  // }).catch((error) => {
  //   Toast(error.message);
  // })
}

const filterCommonLangs = computed(() => {
  console.log("filterCommonLangs", commonLanguages.value)
  return commonLanguages.value || []
})

// 源语言
function onSelectChange(codeData) {
  console.log("onSelectChange", codeData)
  if (codeData.isCommon) {
    currentParam.value.targetLang = codeData.targetCode
    currentParam.value.sourceLang = codeData.sourceCode
    if (currentParam.value.showLangError) {
      currentParam.value.showLangError = false
    }
  } else {
    currentParam.value.sourceLang = codeData.sourceCode
  }
  filterLangsList()
  // console.log("onSelectChange", popoverRef.value)
  popoverRef.value && popoverRef.value.hide()
}

const filterLangsList = () => {
  let currentName = ""
  let translateName = ""
  for (let i = 0; i < languages.value.length; i++) {
    let item = languages.value[i]
    if (item.code === currentParam.value.targetLang) {
      currentName = item.name
    }
    if (item.code === currentParam.value.sourceLang) {
      translateName = item.name
    }
  }
  currentParam.value.currentLangsName = currentName
  currentParam.value.translateLangsName = translateName
}

// 目标语言
function onTargetChange(codeData) {
  if (codeData.isCommon) {
    currentParam.value.targetLang = codeData.targetCode
    currentParam.value.sourceLang = codeData.sourceCode
  } else {
    currentParam.value.targetLang = codeData.targetCode
  }
  if (currentParam.value.showLangError) {
    currentParam.value.showLangError = false
  }
  filterLangsList()
  popoverTargetRef.value && popoverTargetRef.value.hide()
}

function switchLangs() {
  let sourceLang = currentParam.value.sourceLang
  let targetLang = currentParam.value.targetLang
  currentParam.value.sourceLang = targetLang
  currentParam.value.targetLang = sourceLang
  filterLangsList()
}

function onLockLang() {

}

onUnmounted(() => {
  eventBus.all.delete("eventSourceOutPutText")
  eventBus.all.delete("eventSourceSuccess")
  eventBus.all.delete("eventSourceFail")
  eventBus.all.delete("eventSourceConnetFail")
  eventBus.all.delete("onHistoryItemClick")
  eventBus.all.delete("onHistoryItemDelete")
})

onMounted(() => {
  // getSensitiveThesaurus()
  basicStore.getSensitiveWords()
  // 监听eventSource 
  // 传输中
  eventBus.on('eventSourceOutPutText', (data) => {
    console.log("eventSourceOutPutText", data)
    if (data) {
      let text = JSON.parse(data) && JSON.parse(data).text
      let maxLength = messages.value.length
      for (let index = messages.value.length - 1; index >= 0; index--) {
        const element = messages.value[index];
        if (element.chatId == -1) {
          let oldText = element.msgJsonContent.text
          messages.value[index].msgJsonContent.text = oldText + text
          document.documentElement.getBoundingClientRect()
          // console.log("eventSourceOutPutText=>", oldText, messages.value[ index ].msgJsonContent.text)
          break
        }
      }
    }
  });

  // 传输完成
  eventBus.on('eventSourceSuccess', (data) => {
    if (messages.value.length > 0 && data) {
      let messageData = JSON.parse(data) && JSON.parse(data)
      let maxLength = messages.value.length
      console.log("eventSourceSuccess===", messageData, messages.value)
      if (messageData.aiTranslateMessage) {
        // 游客文本翻译给予一个唯一的chatId
        if (!token.value) {
          messageData.aiTranslateMessage.chatId = visitorChatId.value
        }
        if (messageData.aiTranslateMessage.msgContent) {
          messageData.aiChatMessage = messageData.aiTranslateMessage
          messageData.aiChatMessage.msgContent = JSON.parse(messageData.aiTranslateMessage.msgContent)
          messageData.aiChatMessage.msgJsonContent = messageData.aiTranslateMessage.msgContent
          messageData.aiChatMessage.msgType = 1
        }
        messages.value[maxLength - 1] = messageData.aiTranslateMessage
        if (messageData.aiTranslateMessage.chatId) {
          chatMessage.setAIChatId(messageData.aiTranslateMessage.chatId)
        }
      }
      chatMessage.setRemainNumInfo(messageData.remainCharsNum || 0, messageData.remainTrialNum || 0, messageData.costTokens || 0)
      getUserByToken()
      onUpdataRemainCharsNum()
    }
    chatInput.value && chatInput.value.setDisable(false);
  });

  // 传输失败
  eventBus.on('eventSourceFail', (data) => {
    if (data) {
      let result = JSON.parse(data)
      if (result && (result.code == "20023" || result.code == "10019" || result.code == "10040")) {
        // 修改最后一条消息为充值消息
        setTimeout(() => {
          let maxLength = messages.value.length
          for (let index = messages.value.length - 1; index >= 0; index--) {
            const element = messages.value[index];
            if (element.chatId == -1) {
              messages.value[maxLength - 1].msgType = 2
              // messages.value[maxLength - 1].trialCount = result.errParamJson.trialCount
              messages.value[maxLength - 1].msgJsonContent.text = ""
              messages.value[maxLength - 1].chargeStatus = result.code == "10040" ? 2 : 1
              break
            }
          }
          chatInput.value && chatInput.value.setDisable(false);
        }, 500)
        return
      } else if (result && result.code == "403") {
        deleteLastMessage()
        // loginOpenDialog()
      } else {
        deleteLastMessage()
      }
    }
  });

  // 链接失败
  eventBus.on('eventSourceConnetFail', (data) => {
    deleteLastMessage()
  });

  // 历史记录点击
  eventBus.on('onHistoryItemClick', (item) => {
    console.log('onHistoryItemClick', item)
    if (item.id != chatMessage.getAIChatId()) {
      messages.value = []
      chatMessage.resetParams()
      chatMessage.setAIChatId(item.id)
      onHistoryRefresh()
    }
  })

  eventBus.on('onHistoryItemDelete', (ids) => {
    console.log('onHistoryItemDelete', ids)
    if (ids.length > 0) {
      let findIndex = ids.findIndex(item => item == chatMessage.getAIChatId())
      if (findIndex >= 0) {
        messages.value = []
        chatMessage.resetParams()
        chatMessage.setAIChatId(null)
      }
    }
  })

  // 获取当前语言
  var code = useI18n().locale.value
  if (code == 'zh') {
    code = 'zh-CN'
  } else if (code == 'tw') {
    code = 'zh-TW'
  }
  chatMessage.setLangCode(code)
  currentLang.value = code

  chatMessage.getInitAIChatEngines((() => {
    updataEngine(chatMessage.getAllModeInfo())
  }), (() => {

  }), true, userInfo.value)

})

</script>

<style scoped lang="scss">
.upload-view {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  justify-content: center;
}

.homepageBg {
  display: flex;
  width: 100%;
  min-height: 200px;
  max-height: 700px;
  // background-color: var(--bg-color);
  justify-content: center;
  overflow-y: auto;
  scrollbar-width: none;
}

.upload_main {
  margin: 50px 40px 50px 40px;
  // border-style: dashed;
  // border-width: 2px;
  // border-color: #0078d5;
  width: calc(100% - 80px);
  flex-direction: column;
  align-items: center;
  display: flex;
  flex: 1;
  flex-grow: 1;

  .chooseFile {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }

  .ai-all-box {
    width: 100%;
    // min-height: 338px;
    // min-height: 234px;
    position: relative;
    display: flex;
    flex-direction: column;
    position: -webkit-sticky;
    position: sticky;
    bottom: 0;
    z-index: 1;
    background-color: white;
  }

  .ai-order-box {
    width: calc(100%);
    height: 34px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    background-color: white;

    .ai-order-box-left {
      display: flex;
      flex-direction: row;
      align-items: center;
    }

    .ai-order-box-right {
      display: flex;
      flex-direction: row;
      align-items: center;
    }

    .ai-btn {
      width: 30px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px 4px 4px 4px;

      &:hover {
        background: #F5F5F5;
      }
    }

    .ai-question-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px 4px 4px 4px;
      background: #F5F5F5;
      padding: 0 10px;
      height: 30px;
      cursor: pointer;
      margin-bottom: 5px;

      .ai-question-btn-text {
        font-size: 14px;
        color: #595959;
      }

      &:active .ai-question-btn-text {
        color: #2590E1;
      }
    }

    .ai-question-unClick-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px 4px 4px 4px;
      background: #F5F5F5;
      padding: 0 10px;
      height: 30px;
      margin-bottom: 5px;
      opacity: 0.6;

      .ai-question-btn-text {
        font-size: 14px;
        color: #595959;
      }
    }
  }

  .ai-input-box {
    width: 100%;
    // min-height: 338px;
    // min-height: 200px;
    border-radius: 5px;
    position: relative;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    border: 1px solid #BFBFBF;
    background-color: white;

    .ai-input-box-top {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;

      .translateChoose_top_view {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: calc(100% - 40px);
        margin: 10px 20px;
        border-bottom: 1px solid #F2F2F2;
        .chooseSelect-column {
          flex-direction: column;
          align-items: flex-start;
          padding: 10px 0;
          width: 80%;

          .chooseSelect-column-item {
            display: flex;
            flex-direction: row;
            align-items: center;
            width: 100%;
            flex-wrap: wrap;
            gap: 10px;

            .translate-setting {
              display: flex;
              flex-direction: row;
              align-items: center;
              flex: 1;
            }

            .k-shake {
              display: flex;
              flex-direction: row;
              padding: 0px 15px;
              background-color: #F5F5F5;
              border-radius: 2px;
              align-items: center;
              height: 40px;

              .item-child {
                display: flex;
                flex-direction: row;
                padding: 5px 0;
                .el-dropdown-link {
                  color: var(--text-color);
                  display: flex;
                  font-size: 13px;
                  align-items: center;
                  cursor: pointer;
                  &:hover {
                    opacity: 0.6;
                  }
                }
                .last-div {
                  padding: 0 10px;
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                  height: 24px;
                  background-color: #E5F2FB;
                  border-radius: 4px 4px 4px 4px;
                  cursor: pointer;
                  .lastTitle {
                    cursor: pointer;
                    font-size: 12px;
                    color: var(--progress-bg-color)
                  }
                }
              }
            }
          }
        }
      }
    }

    .ai-input-box-input {
      display: flex;
      width: 100%;
      min-height: 230px;
      // margin-top: auto;
      flex: 1;
    }
  }

  .ai-chat-box {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 255, 255, 0.8);
    z-index: 1;
    overflow-y: auto;
    scrollbar-width: none;

    .ai-loading-text {
      color: var(--progress-bg-color);
      font-size: 14px;
      margin-top: 20px;
    }

    .ai-loading-text-complete {
      color: #34A853;
      font-size: 14px;
      margin-top: 20px;
    }

    .ai-progress {
      .custom-progress {
        :deep(.u-progress-text) {
          font-size: 12px;
        }
      }
    }

    .no-data-view {
      padding: 15px 0 30px 0;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: center;

      i {
        font-size: 38px;
        color: var(--progress-bg-color);
      }

      p {
        margin-top: 5px;
        font-weight: bold;
      }
    }
  }
}

.engineDev {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px 15px;
  background-color: #F5F5F5;
  border-radius: 2px;
  height: 40px;

  .engine_view {
    display: flex;
    width: 100%;
  }

  .el-dropdown-translate-mode {
    height: 18px;
    cursor: pointer;

    .el-dropdown-link {
      cursor: pointer;
      display: flex;
      height: 18px;
      border-radius: 4px;
      align-items: center;
      justify-content: center;

      .title {
        font-size: 14px;
        color: var(--text-color1);
        text-align: center;
      }

      .triangle-down {
        width: 0;
        height: 0;
        border-left: 4px solid transparent;
        /* 左边框透明 */
        border-right: 4px solid transparent;
        /* 右边框透明 */
        border-top: 5px solid #000;
        /* 上边框为实色，形成倒三角 */
      }
    }
  }

  .engineDev_tipsTitle {
    display: flex;
    align-items: center;
    width: 100%;
    cursor: pointer;

    .translate_engine {}
  }

  .engineDev_select {
    color: #262626;
    font-size: 14px;
    font-weight: bold;
    margin-left: 10px;
    margin-right: 10px;
  }

  .iconfont {}

  .engine_dropdown {}
}
</style>

<style scoped lang="scss">
.enterprise-text-translate {
  --enterprise-primary: #2b7de9;
  --enterprise-ink: #1f2329;
  --enterprise-sub: #51565d;
  --enterprise-muted: #98a2b3;
  --enterprise-line: #e8ebf0;

  .homepageBg {
    max-height: none;
    overflow: visible;
  }

  &.has-messages {
    height: 100%;
    min-height: 0;
    justify-content: flex-start;

    .homepageBg {
      flex: 1;
      min-height: 0;
      overflow: hidden;
    }

    .upload_main {
      height: 100%;
      min-height: 0;

      .ai-chat-box {
        flex: 1;
        min-height: 0;
        justify-content: flex-start;
        overflow-y: auto;
        overscroll-behavior: contain;
      }

      .ai-all-box {
        flex: 0 0 auto;
      }
    }
  }

  .upload_main {
    align-items: stretch;
    width: 100%;
    margin: 0;

    .ai-chat-box {
      align-items: stretch;
    }

    .ai-all-box {
      position: relative;
      bottom: auto;
      background: transparent;
    }

    .ai-order-box {
      height: 34px;
      margin-bottom: 8px;
    }

    .ai-input-box {
      overflow: hidden;
      border: 1px solid var(--enterprise-line);
      border-radius: 12px;

      .ai-input-box-top {
        align-items: stretch;

        .translateChoose_top_view {
          box-sizing: border-box;
          width: 100%;
          min-height: 62px;
          margin: 0;
          padding: 14px 18px;
          border-bottom: 1px solid #eef1f5;

          .chooseSelect-column {
            width: auto;
            padding: 0;

            .chooseSelect-column-item {
              gap: 14px;

              .k-shake {
                box-sizing: border-box;
                width: 173px;
                height: 34px;
                gap: 8px;
                padding: 0 12px;
                background: #f2f4f7;
                border-radius: 8px;

                .item-child {
                  padding: 0;

                  .el-dropdown-link {
                    gap: 8px;
                  }
                }
              }
            }
          }
        }
      }
    }

    .ai-input-box-input {
      min-height: 230px !important;
    }
  }

  .enterprise-text-inline-icon,
  .enterprise-text-swap-icon {
    flex: 0 0 auto;
    color: #8f959e;
  }

  .enterprise-text-swap-icon {
    cursor: pointer;
  }

  .enterprise-text-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-left: auto;
  }

  .enterprise-text-action {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    padding: 0;
    color: var(--enterprise-sub);
    background: #fff;
    border: 1px solid #d9dee5;
    border-radius: 8px;
    cursor: pointer;

    &:hover {
      color: var(--enterprise-primary);
      border-color: #b7d4fa;
      background: #f7faff;
    }

    &.is-primary {
      color: #fff;
      background: var(--enterprise-primary);
      border-color: var(--enterprise-primary);
    }
  }
}
</style>

<style lang="scss">
.custom-popover.el-popover {
  background-color: #303133 !important;
  border-color: transparent !important;
  max-height: 300px;

  .el-popper__arrow::before {
    background: #303133 !important;
    border-color: transparent !important;
    // border-left-color: rgba(255, 255, 255, 0.8)
  }
}

.TranslateUploadPDFItem {
  .el-dialog {
    width: 400px !important;
  }
}

.spinner {
  animation: spin 1s linear infinite;
  /* 旋转动画 */
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
    /* 起始角度 */
  }

  100% {
    transform: rotate(360deg);
    /* 结束角度 */
  }
}

.popoverDiv {
  width: 100%;
  display: flex;
  flex-direction: column;

  .title {
    color: white;
    font-size: 12px;
  }
}
</style>
<style>
.TranslateUploadPDFItem input {
  font-size: 16px !important;
  /* 设置字体大小 */
}
</style>
